import axios from '../../axios.js';
import { createRequestSequence } from '../requestSequence';

const logsSeq = createRequestSequence();

const getAllLogs = async ({ commit }, object) => {
  const page_number = object.page_number
    ? `page_numberr=${object.page_number}&`
    : '';
  const on_page = object.on_page ? `on_page=${object.on_page}&` : '';
  const filter_param = object.search_param
    ? `filter_param=${object.search_param}&`
    : '';
  const type =
    object.filter_param && object.filter_param !== 'ALL'
      ? `type=${object.filter_param}&`
      : '';
  const url = `/api/log/all?${page_number}${on_page}${filter_param}${type}`;
  const requestId = logsSeq.next();
  await axios
    .get(url)
    .then((response) => {
      if (!logsSeq.isLatest(requestId)) return;
      commit('SET_LOGS', response);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default {
  getAllLogs,
};
